"use client";

import React from "react";
import Image from "next/image";
import { getImageURL } from "@/helpers/imageURLHelper";

const GGSMasthead = ({ key, backgroundImage }) => {
  return (
    <>
      <div className="tps-masthead">
        <div className="ggs-masthead-image-wrapper">
          <div className="ggs-masthead-image-inner">
            <Image
              src={getImageURL(backgroundImage?.url)}
              alt={backgroundImage?.alternativeText || ""}
              className="ggs-masthead-image"
              width={backgroundImage?.width || 1200}
              height={backgroundImage?.height || 600}
              sizes="100vw"
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default GGSMasthead;
